import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

interface ThemeState {
  isDark: boolean;
}

const initialState: ThemeState = { isDark: false };

/** Store global para gestionar el tema claro/oscuro de la aplicación. */
export const ThemeStore = signalStore(
  { providedIn: 'root' },
  withState<ThemeState>(initialState),
  withComputed(({ isDark }) => ({
    /** Ícono de PrimeIcons según el tema activo. */
    themeIcon: computed(() => (isDark() ? 'pi pi-sun' : 'pi pi-moon')),
    /** Tooltip del botón de toggle. */
    themeTooltip: computed(() => (isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro')),
  })),
  withMethods((store) => ({
    /**
     * Inicializa el tema al arrancar la app.
     * Prioridad: localStorage → preferencia del sistema operativo.
     */
    initializeTheme(): void {
      const saved = localStorage.getItem('theme');
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const dark = saved ? saved === 'dark' : prefersDark;
      patchState(store, { isDark: dark });
      document.documentElement.classList.toggle('dark', dark);
    },
    /** Alterna entre tema claro y oscuro, persistiendo la elección en localStorage. */
    toggleTheme(): void {
      const newDark = !store.isDark();
      patchState(store, { isDark: newDark });
      localStorage.setItem('theme', newDark ? 'dark' : 'light');
      document.documentElement.classList.toggle('dark', newDark);
    },
  }))
);
